import { accreditations } from "@/data";

const Accreditations = () => (
  <section className="accr-section">
    <div className="container">
      <span className="accr-section__label">Accredited &amp; certified by</span>
      <div className="accr-section__grid">
        {accreditations.map((a) => (
          <div className="accr-item" key={a.name}>
            <div className="accr-item__logo">
              <img src={a.logo} alt={a.name} loading="lazy" />
            </div>
            <p className="accr-item__desc">{a.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Accreditations;
